/**
 * How far a participant got in registration, from their participant document.
 * - registered: entered an ID (or email), never pressed Connect Google Health
 * - authorizing: pressed Connect but never finished (stopped at Google's warning or
 *   permissions screen, closed the tab, or the connection failed)
 * - connected: connected now
 * - disconnected: connected once, then disconnected or access was revoked
 */
export default function participantStage(p) {
  const h = p?.health;
  if (h?.connected === true) return 'connected';
  if (h?.connectedAt || h?.healthUserId) return 'disconnected';
  if (h?.status) return 'authorizing';
  return 'registered';
}

export const STAGE_LABEL = {
  registered: ['registered, not connected', 'ja-chip-partial'],
  authorizing: ['pressed Connect, did not finish', 'ja-chip-partial'],
  connected: ['connected', 'ja-chip-active'],
  disconnected: ['disconnected', 'ja-chip-inactive'],
};
